import { service } from '@maia/insurance';
import { queryOptions } from '@tanstack/react-query';

export function getProductFilterOptions() {
  return queryOptions({
    queryKey: ['productFilterOptions'],
    queryFn: () => service.getFilterProducts(),
  });
}
